import { NavLink } from "react-router-dom";
import { isSwitchedFromSuperAdminSession } from "../../../../utils/auth";
import {
  filterMenusForSubUser,
  getSubUserPagePermissions,
  isSubUser,
} from "../../../../utils/subUser";
import { AdminMenus } from "./admin";
import { UserMenus } from "./user";

const SYSTEM_LOGS_MENU_ITEM = {
  label: "System Logs",
  key: "system-logs",
  icon: "ki-outline ki-notepad-bookmark",
};

const filterUserMenus = (menus, user) => {
  const parentUserId = user?.user?.user_data?.parent_user_id;
  
  // Hide menu if parent_user_id has ANY value (including 0, 1, 2, 3, etc.)
  // Show menu only when parent_user_id is null
  if (parentUserId !== null) {
    return menus
      .filter(menu => menu.key !== "settings/manage-users")
      .map(menu => ({
        ...menu,
        children: menu.children?.filter(child => child.key !== "settings/manage-seller"),
      }));
  }
  
  return menus;
};

export const FindMenus = (type, user) => {
  const resolvedType = type === "user" || isSubUser(user) ? "user" : type;

  let menus;
  if (resolvedType === "user") {
    menus = filterUserMenus(UserMenus, user);
    if (isSubUser(user)) {
      menus = filterMenusForSubUser(menus, getSubUserPagePermissions(user));
    } else if (isSwitchedFromSuperAdminSession(user)) {
      menus = [...menus, SYSTEM_LOGS_MENU_ITEM];
    }
  } else if (resolvedType === "admin") {
    menus = AdminMenus;
  } else if (resolvedType === "superAdmin") {
    menus = AdminMenus;
  } else {
    menus = [];
  }

  const renderLabel = (item) => (
    <NavLink to={item.key}>
      <span className="sidebar-menu-label">
        {item.label}
        {item.beta && (
          <span className="sidebar-beta-tag">Beta</span>
        )}
      </span>
    </NavLink>
  );

  return menus?.map((d, i) => {
    if (d?.children) {
      return {
        ...d,
        icon: <i className={`${d.icon} fs-1`} />,
        label: d.label,
        children: d?.children?.map((child) => ({
          ...child,
          className: child.className || "sidebar-submenu-item",
          label: renderLabel(child),
        })),
      };
    }

    return {
      ...d,
      icon: <i className={`${d.icon} fs-1`} />,
      label: renderLabel(d),
    };
  });
};